import HelpOrTip from "../components/HelpOrTip";
import * as theme from "../theme";

const MainPane = (props) => {
  return (
    <div style={{ ...theme.fwfh, display: "flex", flexDirection: "column" }}>
      <div
        style={{
          width: "100%",
          height: props.hideHelpOrTip
            ? "100%"
            : theme.SCALES.heightAfterHelpOrTip,
          zIndex: 1,
        }}
      >
        {props.children}
      </div>
      {/* TODO: TO HIDE HELPORTIP OR NOT NEEDS TO COME FROM REDUX STORE */}
      {props.hideHelpOrTip ? null : (
        <div
          style={{
            boxShadow: "0px -4px 30px #AFB6CC",
            zIndex: 2,
            height: theme.SCALES.helpOrTipHeight,
          }}
        >
          <HelpOrTip></HelpOrTip>
        </div>
      )}
    </div>
  );
};

export default MainPane;
